import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard.js';
import { Layout } from './components/Layout.js';
import { AuthProvider } from './contexts/AuthContext.js';
import { makeQueryClient } from './lib/queryClient.js';
import { ActividadesEdit } from './routes/Actividades/Edit.js';
import { ActividadesList } from './routes/Actividades/List.js';
import { ActividadesNew } from './routes/Actividades/New.js';
import { ActividadesView } from './routes/Actividades/View.js';
import { AdelantosEdit } from './routes/Adelantos/Edit.js';
import { AdelantosList } from './routes/Adelantos/List.js';
import { AdelantosNew } from './routes/Adelantos/New.js';
import { AdelantosView } from './routes/Adelantos/View.js';
import { Admin } from './routes/Admin/Admin.js';
import { Dashboard } from './routes/Dashboard/Dashboard.js';
import { Home } from './routes/Home.js';
import { Login } from './routes/Login.js';
import { NinasEdit } from './routes/Ninas/Edit.js';
import { NinasList } from './routes/Ninas/List.js';
import { NinasNew } from './routes/Ninas/New.js';
import { NinasView } from './routes/Ninas/View.js';
import { NotFound } from './routes/NotFound.js';
import { OutboxView } from './routes/Outbox/Outbox.js';
import { Placeholder } from './routes/Placeholder.js';

const queryClient = makeQueryClient();

const router = createBrowserRouter([
  // Login (sin AuthGuard — accesible siempre)
  {
    path: '/login',
    element: (
      <Layout>
        <Login />
      </Layout>
    ),
  },
  // Protected routes (wrapped en AuthGuard)
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    errorElement: (
      <Layout>
        <NotFound />
      </Layout>
    ),
    children: [
      { index: true, element: <Home /> },
      // FWA-PWA-023 — Ninas master + form (sprint-10 carry-over)
      { path: 'ninas', element: <NinasList /> },
      { path: 'ninas/new', element: <NinasNew /> },
      { path: 'ninas/:id', element: <NinasView /> },
      { path: 'ninas/:id/edit', element: <NinasEdit /> },
      // FWA-PWA-029 — Outbox offline view (sprint-11)
      { path: 'outbox', element: <OutboxView /> },
      // FWA-PWA-030 — Actividades capture FE (sprint-12)
      { path: 'actividades', element: <ActividadesList /> },
      { path: 'actividades/new', element: <ActividadesNew /> },
      { path: 'actividades/:id', element: <ActividadesView /> },
      { path: 'actividades/:id/edit', element: <ActividadesEdit /> },
      // FWA-PWA-031 — Adelantos FE (sprint-13)
      { path: 'adelantos', element: <AdelantosList /> },
      { path: 'adelantos/new', element: <AdelantosNew /> },
      { path: 'adelantos/:id', element: <AdelantosView /> },
      { path: 'adelantos/:id/edit', element: <AdelantosEdit /> },
      {
        path: 'capacitaciones',
        element: (
          <Placeholder
            title="Capacitaciones"
            storyId="FWA-PWA-026"
            description="Registro de capacitaciones del staff distrital."
          />
        ),
      },
      // FWA-PWA-032 — Dashboard agregado (sprint-14)
      { path: 'dashboard', element: <Dashboard /> },
      // FWA-PWA-033 — Admin panel (sprint-15)
      { path: 'admin', element: <Admin /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
